/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ApiServerTestTryDnsGet$Params {
  secret?: string;
  address?: string;

/**
 * User's Working Group
 */
  UserWorkingGroup?: String;
}

export function apiServerTestTryDnsGet(http: HttpClient, rootUrl: string, params?: ApiServerTestTryDnsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
  const rb = new RequestBuilder(rootUrl, apiServerTestTryDnsGet.PATH, 'get');
  if (params) {
    rb.query('secret', params.secret, {});
    rb.query('address', params.address, {});
    rb.header('UserWorkingGroup', params.UserWorkingGroup, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<string>;
    })
  );
}

apiServerTestTryDnsGet.PATH = '/api/server-test/try-dns';
